"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _questionSummaryHelper = require("../hooks/questionnaire/helpers/questionSummaryHelper");
var _questionnaireUtil = require("../utils/questionnaireUtil");
var _utils = require("../utils/utils");
var _logger = require("./logger");
class WindowAPI {
  //-----------------------------------------------
  //-------------------- Constructor --------------
  //-----------------------------------------------
  constructor(_ref) {
    var _this = this,
      _ref4;
    let {
      enabled,
      exposeMarketFlows,
      enableDynamicFlow,
      openGuidedSellingModal,
      setFlags,
      setMetadata,
      setSkippedQuestionIds,
      resetQuestionnaire,
      setAdditionalSummaries,
      config
    } = _ref;
    //-----------------------------------------------
    //-------------------- Properties ---------------
    //-----------------------------------------------
    this.enableDynamicFlow = void 0;
    this.enabled = void 0;
    this.exposeMarketFlows = void 0;
    this.openGuidedSellingModal = void 0;
    this.setMetadata = void 0;
    this.setFlags = void 0;
    this.setSkippedQuestionIds = void 0;
    this.setAdditionalSummaries = void 0;
    this.resetQuestionnaire = void 0;
    this.windowVariable = window;
    this.flows = void 0;
    this.config = void 0;
    this.appName = void 0;
    this.lastCalledFlow = void 0;
    this.exposeLaunchFunction = () => {
      const launchFunction = params => {
        const currentFlow = {
          type: 'launchGS',
          input: JSON.stringify(params)
        };
        if (this.evaluateReset(currentFlow)) {
          this.resetQuestionnaire();
        }
        this.lastCalledFlow = currentFlow;
        if (this.enableDynamicFlow) {
          var _params$enable, _params$recommendatio, _params$hideQuestions, _params$additionalSum;
          this.setFlags((_params$enable = params === null || params === void 0 ? void 0 : params.enable) !== null && _params$enable !== void 0 ? _params$enable : []);
          this.setMetadata((_params$recommendatio = params === null || params === void 0 ? void 0 : params.recommendationCategories) !== null && _params$recommendatio !== void 0 ? _params$recommendatio : []);
          this.setSkippedQuestionIds((_params$hideQuestions = params === null || params === void 0 ? void 0 : params.hideQuestionsById) !== null && _params$hideQuestions !== void 0 ? _params$hideQuestions : []);
          this.setAdditionalSummaries((_params$additionalSum = params === null || params === void 0 ? void 0 : params.additionalSummaries) !== null && _params$additionalSum !== void 0 ? _params$additionalSum : []);
        } else {
          this.setFlags([]);
          this.setMetadata([]);
          this.setSkippedQuestionIds([]);
          this.setAdditionalSummaries([]);
        }
        this.openGuidedSellingModal();
      };
      this.windowVariable.guidedSelling[this.appName].launchGS = launchFunction;
    };
    this.exposeFlows = () => {
      var _this$flows;
      _logger.Logger.info({
        segments: [_logger.Logger.LOGGER_SEGMENTS.SERVICES]
      })('exposeFlows', this.flows);
      if (!this.exposeMarketFlows || !((_this$flows = this.flows) !== null && _this$flows !== void 0 && _this$flows.length)) return;
      this.flows.forEach(flowCallback => {
        this.windowVariable.guidedSelling[this.appName][flowCallback({}).name] = input => {
          var _flow$params;
          const flow = flowCallback(input, this.config);
          const currentFlow = {
            type: flow.name,
            input: JSON.stringify(input)
          };
          if (this.evaluateReset(currentFlow)) {
            this.resetQuestionnaire();
          }
          this.lastCalledFlow = currentFlow;
          this.setFlags(flow.params.enable);
          this.setMetadata((_flow$params = flow.params) === null || _flow$params === void 0 ? void 0 : _flow$params.recommendationCategories);
          this.setSkippedQuestionIds(flow.params.hideQuestionsById);
          const summaries = this.calculateSummaries(flow.params.hideQuestionsById, input);
          if (summaries.length) {
            this.setAdditionalSummaries(summaries);
          }
          this.openGuidedSellingModal();
        };
      });
    };
    this.calculateSummaries = function () {
      let questionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return questionIds.map(id => {
        var _ref2, _Object$entries$find, _question$summaryDeli, _translateQuestionTex;
        const inputSegmentValue = (_ref2 = (_Object$entries$find = Object.entries(input).find(_ref3 => {
          let [key] = _ref3;
          return id.toLowerCase().includes(key.toLowerCase());
        })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1]) !== null && _ref2 !== void 0 ? _ref2 : '';
        const question = _this.config.questions.find(question => question.id === id);
        const summaryDelimiter = (_question$summaryDeli = question === null || question === void 0 ? void 0 : question.summaryDelimiter) !== null && _question$summaryDeli !== void 0 ? _question$summaryDeli : [];
        const formattedInputSegment = (0, _questionSummaryHelper.getChoicesSummaryValue)(inputSegmentValue.split(',').map(value => `<value>${(0, _utils.capitalize)(value.trim().toLowerCase())}</value>`), summaryDelimiter);
        const summary = (_translateQuestionTex = (0, _questionnaireUtil.translateQuestionText)(question === null || question === void 0 ? void 0 : question.summary, _this.config.market)) === null || _translateQuestionTex === void 0 ? void 0 : _translateQuestionTex.replace('{{value}}', formattedInputSegment);
        if (!summary) {
          return;
        }
        return {
          id,
          summary
        };
      }).filter(Boolean);
    };
    this.evaluateReset = currentCall => !this.lastCalledFlow || this.lastCalledFlow.type !== currentCall.type || this.lastCalledFlow.input !== currentCall.input;
    this.enabled = enabled;
    this.exposeMarketFlows = exposeMarketFlows;
    this.enableDynamicFlow = enableDynamicFlow;
    this.openGuidedSellingModal = openGuidedSellingModal;
    this.setFlags = setFlags;
    this.setMetadata = setMetadata;
    this.setSkippedQuestionIds = setSkippedQuestionIds;
    this.resetQuestionnaire = resetQuestionnaire;
    this.setAdditionalSummaries = setAdditionalSummaries;
    this.config = config;
    this.appName = (_ref4 = config === null || config === void 0 ? void 0 : config.appId) !== null && _ref4 !== void 0 ? _ref4 : 'entryPoint';
    this.createWindowObject();
  }
  //-----------------------------------------------
  //-------------------- Methods ------------------
  //-----------------------------------------------
  createWindowObject() {
    if (!this.windowVariable.guidedSelling) {
      this.windowVariable.guidedSelling = {};
    }
    this.windowVariable.guidedSelling[this.appName] = {};
    this.exposeLaunchFunction();
    this.exposeFlows();
  }
}

// Example usage

// guidedSelling.handsetFlowChile.launchGS({
//   recommendationCategories: [{ category: 'handset', filters: { brand: ['Apple'] } }],
//  enable: ['brand-flow-opened-by-window'],
//   hideQuestionsById: ['preferred-device-brand'],
// });
exports.default = WindowAPI;